import { motion } from "framer-motion";

export default function SectionLabel({ eyebrow, title, subtitle, center = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className={`mb-16 md:mb-20 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}
    >
      <div className={`flex items-center gap-3 mb-5 ${center ? "justify-center" : ""}`}>
        <span className="w-8 h-px bg-[#C5A059]" />
        <span className="text-[#8B5A2B] text-[11px] tracking-[0.4em] uppercase font-body">
          {eyebrow}
        </span>
        <span className="w-8 h-px bg-[#C5A059]" />
      </div>
      <h2 className="font-display font-light text-stone-900 text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-stone-600 font-light text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
